const prefixes = ['Webkit', 'Moz', 'ms', 'Ms', 'O'];
const docElemStyle = document.documentElement.style;

export const getStyle = window.getComputedStyle ?
  (element: Element) => getComputedStyle(element, null) :
  (element: Element) => (element as any).currentStyle;

export const getStyleProperty = (propName: keyof CSSStyleDeclaration) => {
  // test standard property first
  if (typeof docElemStyle[propName] === 'string') {
    return propName;
  }

  // capitalize
  const prop = `${ (propName as string).charAt(0).toUpperCase() }${ (propName as string).slice(1) }`;

  // test vendor specific properties
  let prefixed: keyof CSSStyleDeclaration;
  for (let i = 0, len = prefixes.length; i < len; i++) {
    prefixed = (prefixes[i] + prop) as keyof CSSStyleDeclaration;
    if (typeof docElemStyle[prefixed] === 'string') {
      return prefixed;
    }
  }

  return propName;
};

export const getOuterHeight = (element: HTMLElement) => {
  const style = getComputedStyle(element);
  return element.offsetHeight + parseInt(style.marginTop || '0', 10) + parseInt(style.marginBottom || '0', 10);
};
